<template>
    <header>
        <section :class="classes">
            <section class="wishlist-header-title">
                <h3>- {{ $t('wishlist.view.preTitle') }} -</h3>
                <h1>{{ title }}</h1>
            </section>
            <section class="wishlist-header-content">
                <slot></slot>
            </section>
        </section>
        <div v-if="!isPublic" class="public-link-block">
            <a class="public-link" :href="shareLink">{{ $t('wishlist.seePublicPage') }}</a>
        </div>
    </header>
</template>
<script>
import { defineComponent, unref } from 'vue';
import MainWithAside from '@components/Account/MainWithAside.vue';
import WishlistDetails from '@components/Wishlist/WishlistDetails.vue';
import PageTitle from '@components/Typography/PageTitle.vue';
import { useAppStore } from '@stores/App';
import { useWishlistStore } from '@stores/Wishlist';

export default defineComponent({
    components: { PageTitle, MainWithAside, WishlistDetails },
    props: {
        wishlist: null,
        isPublic: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    computed: {
        classes() {
            const app = useAppStore();
            return [unref(app.getBreakpoints().active()), this.wishlist?.type, 'wishlist-header'];
        },
        title() {
            return this.wishlist?.name;
        },
        shareLink() {
            const wishlist = useWishlistStore();
            return wishlist.getShareLink(this.wishlist?.uuid);
        },
    },
});
</script>
<style lang="scss" scoped>
.wishlist-header {
    margin-bottom: 2rem;
    &.sm {
        ::v-deep(i) {
            display: block;
        }
    }
}

.wishlist-header {
    text-align: center;
    padding: 3rem 2rem;
    color: var(--theme-title-color);
    background: var(--theme-bg);
    position: relative;

    &-title {
        padding: 1rem 0;

        h1 {
            font-size: 2rem;
            font-weight: 300;
            font-family: Chronicle, serif;
            i {
                margin: 0 0.5rem;
            }
        }

        h3 {
            font-size: 20px;
            font-weight: 300;
            font-family: Chronicle, serif;
        }

        h4 {
            font-size: 16px;
            font-weight: 300;
            font-family: Chronicle, serif;
            text-transform: uppercase;
        }
    }

    &:before {
        left: 0;
        right: 0;
        width: 100%;
        bottom: -41px;
        height: 123px;
        content: "";
        z-index: 1;
        position: absolute;
        background-size: auto 100%;
        background-image: var(--theme-decoration);
        background-repeat: no-repeat;
        background-position: center bottom;
    }

    &.standard {
        border: 10px solid var(--theme-bg); /* Outer blue border */
        box-shadow: inset 0 0 0 2px white; /* Inner white border */
    }

    &.christmas:before {
        background-position: center 10px;
    }
}

.public-link-block {
    display: flex;
    font-size: 12px;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    margin-top: 2rem;
}

.public-link {
    display: flex;
    text-transform: uppercase;
    text-decoration: underline;
}
</style>
